var routes = {
    PROFILE: "/profile",
};
export default routes;
